import { createContext } from 'react';

import { EnabledLanguage } from '../interfaces/Language';
import { Stylesheet } from '../interfaces/Stylesheet';

export interface StylesheetProviderStore {
  changeStylesheetLanguage: (lng: EnabledLanguage) => void;
  globalStylesheet: Stylesheet;
  stylesheet: Stylesheet;
}

export const StylesheetContext = createContext({} as StylesheetProviderStore);
